import { unreachable } from '../../../ts-utils';
export const getCommentCreateServerError = (error) => {
    const key = (() => {
        const status = error.status;
        switch (status) {
            case 403:
                return 'toast.error-comment-publish-permission';
            case 429:
                return 'toast.error-comment-publish-throttle';
            case -1:
                return 'toast.error-comment-publish-connection';
            case 413:
            case 400: {
                if ((status === 400 && error.description?.includes('large')) || status === 413) {
                    return 'toast.error-content-size-too-large';
                }
                return 'toast.error-comment-publish-generic';
            }
            default:
                return 'toast.error-comment-publish-generic';
        }
    })();
    return {
        type: 'TRANSLATION',
        key,
    };
};
export function getServerErrorMessage(error) {
    return {
        type: 'TRANSLATION',
        key: (() => {
            switch (error.status) {
                case 403:
                    return 'toast.error-permission';
                case -1:
                    return 'toast.error-connection';
                default:
                    return 'toast.error-generic';
            }
        })(),
    };
}
export function getCommentCreatePermissionErrorMessage() {
    return {
        type: 'TRANSLATION',
        key: 'toast.error-comment-publish-permission',
    };
}
export function getGenericPermissionErrorMessage() {
    return { type: 'TRANSLATION', key: 'toast.error-permission' };
}
export function errorForBi(message) {
    switch (message.type) {
        case 'TOAST': {
            const toastMessage = message.message;
            switch (toastMessage.type) {
                case 'TRANSLATION':
                    return toastMessage.key;
                case 'EXTERNAL_TRANSLATION':
                    return toastMessage.key;
                case 'CUSTOM':
                    return toastMessage.content;
            }
        }
        case 'SILENT':
        case 'MODAL': {
            return '';
        }
        default:
            throw unreachable(message);
    }
}
export const getMessageFromError = (error, options) => {
    const isCreateCommentAction = options?.isCreateCommentAction ?? false;
    switch (error?.type) {
        case 'PERMISSION':
            return {
                type: 'TOAST',
                message: isCreateCommentAction
                    ? getCommentCreatePermissionErrorMessage()
                    : getGenericPermissionErrorMessage(),
            };
        case 'SERVER':
            if (error.status === 428 && error.applicationErrorCode === 'REJECT_BY_SPI_IMPLEMENTER') {
                return { type: 'MODAL', modalType: 'blocked-comment' };
            }
            return {
                type: 'TOAST',
                message: isCreateCommentAction
                    ? getCommentCreateServerError(error)
                    : getServerErrorMessage(error),
            };
        case 'SILENT':
            return { type: 'SILENT' };
        default:
            throw unreachable(error);
    }
};
export const beforeCrudErrorToMessage = (result) => {
    if (typeof result.message === 'string') {
        return { type: 'TOAST', message: { type: 'CUSTOM', content: result.message } };
    }
    if (result.message.type === 'EXTERNAL_TRANSLATION') {
        return { type: 'TOAST', message: { type: 'EXTERNAL_TRANSLATION', key: result.message.key } };
    }
    return { type: 'SILENT' };
};
//# sourceMappingURL=comments-errors.js.map